<script setup lang="ts">
import { useRouteQuery } from '@vueuse/router'

const { t } = useI18n()
const route = useRoute()

const uiStore = useUiStore()
const searchQuery = useRouteQuery('q', '')
const searchQueryInput = ref(searchQuery.value)

const isSearchPage = computed(() => ((route?.name as string) ?? '').includes('search'))
const isCheckoutPage = computed(() => ((route?.name as string) ?? '').includes('checkout'))
const isHomePage = computed(() => ((route?.name as string) ?? '').includes('index'))

watch(isSearchPage, (isSearchPage) => {
  if (!isSearchPage)
    searchQueryInput.value = ''
})
</script>

<template>
  <LayoutHeader />
  <HeaderTopBar />
  <HeaderMenuBar v-if="isHomePage" class="lg:hidden" />
  <slot />
  <NavigationDrawer v-model:open="uiStore.isNavigationDrawerOpen" side="left" />
  <CartDrawer />

  <div class="flex-1" />

  <div v-if="!isCheckoutPage" class="mb6 bg-slate-50">
    <div class="mx-auto max-w-[88rem] py8 lg:px6 sm:px2 sm:py14">
      <MarketingIllustratedIncentives class="grid grid-cols-1 mx-auto max-w-2xl gap-x-8 gap-y-12 lg:grid-cols-2 lg:max-w-none lg:gap-y-16" />
    </div>
  </div>

  <div class="mx-auto max-w-3xl px-4 lg:max-w-[88rem] md:max-w-4xl lg:px6 sm:px-6 sm:px4">
    <NuxtLinkLocale to="/useful-links/contact-us">
      <UiCard class="flex flex-col items-center p-4 sm:flex-row sm:justify-between">
        <div class="mb-4 flex items-center sm:mb-0">
          <div class="relative mr-3 h-8 w-8">
            <Icon name="i-heroicons:chat-bubble-left-ellipsis" class="text-3xl" />
            <span class="absolute top-0 h-3 w-3 flex -right-1">
              <span class="absolute h-full w-full inline-flex animate-ping rounded-full bg-success/40 opacity-75" />
              <span class="relative h-3 w-3 inline-flex rounded-full bg-success" />
            </span>
          </div>

          <div class="sm:ml4">
            <div class="flex items-center">
              <h4 class="text-lg font-semibold">
                {{ t('support_agent.need_assistance.label') }}
              </h4>
            </div>
            <!-- Subtitle -->
            <p class="text-sm text-slate-600 leading-6">
              {{ t('support_agent.hours_of_operation.label') }}
            </p>
          </div>
        </div>
      </UiCard>
    </NuxtLinkLocale>
  </div>

  <!-- App Banner -->
  <LazyNeverMarketingAppPromotionBanner hydrate-never />

  <!-- Footer -->
  <LazyVisibleTheFooter hydrate-on-visible />
</template>
